import { PRODUCTS, GET_PRODUCT, FETCH_MORE_PRODUCTS, SEARCHED_PRODUCTS } from './../types/index';

const initialState = {

    data: [],

    product: {},

    pages: null,

    page: 1,

    next_page: null

};

export default function(state = initialState, action) {

    switch(action.type) {

        case PRODUCTS: 

            return {

                ...state,

                data: action.payload.data,

                pages: action.payload.pages,

                page: action.payload.page,

                next_page: action.payload.next_page

            };

        case FETCH_MORE_PRODUCTS: 

            return {

                ...state,

                data: state.data.concat(action.payload.data),

                pages: action.payload.pages,

                page: action.payload.page,

                next_page: action.payload.next_page

            };

        case GET_PRODUCT:

            return {

                ...state,
    
                product: action.payload
    
            };

        case SEARCHED_PRODUCTS: 

            return {

                ...state,

                data: action.payload,

                pages: null,

                page: 1,

                next_page: null

            };

        default:

            return state;

    }

};